var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAcsfAnalysisGraph(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 845,
    height: 610,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMinYMin meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-14,.cls-15,.cls-17{fill:none;}.cls-1,.cls-15,.cls-16,.cls-17{stroke:#000;}.cls-1,.cls-14,.cls-15,.cls-16,.cls-17{stroke-miterlimit:8;}.cls-1,.cls-16,.cls-17{stroke-width:2px;}.cls-2{fill:#333f50;}.cls-3{fill:#ffc000;}.cls-4{fill:#d2a000;}.cls-5{isolation:isolate;}.cls-6{fill:#f39;}.cls-7{fill:#d6009e;}.cls-8{fill:#00b0f0;}.cls-9{fill:#0085b4;}.cls-10{fill:#7030a0;}.cls-11{fill:#532476;}.cls-12{fill:#00b050;}.cls-13{fill:#007434;}.cls-14{stroke:#333f50;}.cls-17{stroke-linecap:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "line-graph") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 847,
    height: 612,
    id: "canvas_background",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    id: "svg_139",
    height: 605.839607,
    width: 840.841999,
    y: 1.663553,
    x: 2.079007,
    strokeOpacity: "null",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m85.727798,128.181915l-11.75,0l0,-20.32l2.75,0l0,17.93l9,0l0,2.39z",
    fill: "#000000",
    id: "svg_7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m94.307798,128.541915a7.56,7.56 0 0 1 -5.66,-2.05a8,8 0 0 1 -2,-5.84a8.62,8.62 0 0 1 2,-5.93a6.5,6.5 0 0 1 5.11,-2.2a7.13,7.13 0 0 1 2.51001,0.41a5,5 0 0 1 1.90999,1.28a5.89,5.89 0 0 1 1.26001,2.14a9.54,9.54 0 0 1 0.44,3.09l0,1.39l-10.64,0a5.68,5.68 0 0 0 1.34,4.07a4.86,4.86 0 0 0 3.7,1.41a7.21,7.21 0 0 0 1.66,-0.19a7.8,7.8 0 0 0 1.47,-0.49a10.58,10.58 0 0 0 1.17,-0.61a7,7 0 0 0 0.79,-0.55l0.15,0l0,2.8l-1.12,0.44a12.32,12.32 0 0 1 -1.2,0.42q-0.75,0.21 -1.36,0.31a8.92,8.92 0 0 1 -1.53,0.1l-0.00001,0zm3,-9.68a7.15,7.15 0 0 0 -0.25,-1.79a3.7,3.7 0 0 0 -0.63,-1.27a2.87,2.87 0 0 0 -1.15,-0.87a5.14,5.14 0 0 0 -3.48,0a4.15,4.15 0 0 0 -1.3,0.89a4.28,4.28 0 0 0 -0.87,1.33a5.74,5.74 0 0 0 -0.38,1.7l8.06,0.01z",
    fill: "#000000",
    id: "svg_8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m110.947798,126.561915l-0.84,0.65a5.94,5.94 0 0 1 -1,0.66a7.66,7.66 0 0 1 -1.32,0.55a6.46,6.46 0 0 1 -1.78,0.19a4.62,4.62 0 0 1 -3.28,-1.35a4.65,4.65 0 0 1 -1,-1.55a5.2,5.2 0 0 1 -0.37,-1.95a5.14,5.14 0 0 1 0.67,-2.7a4.56,4.56 0 0 1 2.12,-1.77a10.52,10.52 0 0 1 3,-0.81q1.75,-0.22 3.77,-0.33l0,-0.49a3.29,3.29 0 0 0 -0.27,-1.45a2,2 0 0 0 -0.76,-0.85a3,3 0 0 0 -1.2,-0.42a10.21,10.21 0 0 0 -1.46,-0.1a9.85,9.85 0 0 0 -2.09,0.27a14.07,14.07 0 0 0 -2.4,0.77l-0.15,0l0,-2.57q0.71,-0.21 2,-0.45a14.37,14.37 0 0 1 2.62,-0.25a12.15,12.15 0 0 1 2.65,0.25a5.11,5.11 0 0 1 1.94,0.89a3.81,3.81 0 0 1 1.24,1.63a6.41,6.41 0 0 1 0.41,2.43l0,10.43l-2.55,0l0.05,-1.68zm0,-2.13l0,-4.23l-2.31,0.23a12.45,12.45 0 0 0 -2.26,0.4a4.12,4.12 0 0 0 -1.69,1a2.4,2.4 0 0 0 -0.67,1.81a2.54,2.54 0 0 0 0.74,2a3.11,3.11 0 0 0 2.16,0.67a4.59,4.59 0 0 0 2.2,-0.53a9.52,9.52 0 0 0 1.83,-1.35z",
    fill: "#000000",
    id: "svg_9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m125.157808,115.691915l-0.14,0a2.88,2.88 0 0 0 -0.61,-0.1l-0.77,0a5.08,5.08 0 0 0 -2.06,0.45a6.61,6.61 0 0 0 -1.94,1.34l0,10.83l-2.57,0l0,-15.28l2.57,0l0,2.27a11.71,11.71 0 0 1 2.45,-1.75a4.59,4.59 0 0 1 2,-0.51l0.59,0l0.44,0.06l0.04,2.69z",
    fill: "#000000",
    id: "svg_10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m139.137808,128.181915l-2.57,0l0,-8.68a17.52,17.52 0 0 0 -0.1,-2a4.16,4.16 0 0 0 -0.39,-1.45a2,2 0 0 0 -0.87,-0.85a3.46,3.46 0 0 0 -1.53,-0.28a4.37,4.37 0 0 0 -2,0.51a10.14,10.14 0 0 0 -2,1.33l0,11.39l-2.57,0l0,-15.22l2.62,0l0,1.69a10.08,10.08 0 0 1 2.27,-1.57a5.32,5.32 0 0 1 2.36,-0.55a4.39,4.39 0 0 1 3.52,1.48a6.42,6.42 0 0 1 1.26999,4.29l-0.01,9.91l0.00001,0z",
    fill: "#000000",
    id: "svg_11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m145.537808,110.381915l-2.92,0l0,-2.66l2.92,0l0,2.66zm-0.18,17.8l-2.57,0l0,-15.25l2.57,0l0,15.25z",
    fill: "#000000",
    id: "svg_12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m161.087798,128.181915l-2.56999,0l0,-8.68a17.52,17.52 0 0 0 -0.1,-2a4.16,4.16 0 0 0 -0.39,-1.45a2,2 0 0 0 -0.87,-0.85a3.46,3.46 0 0 0 -1.53,-0.28a4.37,4.37 0 0 0 -2,0.51a10.14,10.14 0 0 0 -2,1.33l0,11.39l-2.57,0l0,-15.22l2.57,0l0,1.69a10.08,10.08 0 0 1 2.27,-1.57a5.32,5.32 0 0 1 2.36,-0.55a4.39,4.39 0 0 1 3.52,1.48a6.42,6.42 0 0 1 1.27,4.29l0.04,9.91l-0.00001,0z",
    fill: "#000000",
    id: "svg_13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m165.237808,130.631915l0.75999,0.29q0.51,0.18 1.15,0.35t1.31,0.29a7.34,7.34 0 0 0 1.31001,0.11a5.7,5.7 0 0 0 2,-0.31a3,3 0 0 0 1.28999,-0.87a3.35,3.35 0 0 0 0.61001,-1.3a7.21,7.21 0 0 0 0.18,-1.68l0,-1.34a8,8 0 0 1 -2,1.33a6.33,6.33 0 0 1 -2.5,0.43a5,5 0 0 1 -4.15,-1.94a8.76,8.76 0 0 1 -1.54,-5.57a9.85,9.85 0 0 1 0.53,-3.37a7.71,7.71 0 0 1 1.43,-2.49a5.93,5.93 0 0 1 2,-1.52a5.82,5.82 0 0 1 2.43,-0.53a6.72,6.72 0 0 1 2.05,0.28a8.6,8.6 0 0 1 1.74,0.8l0.15,-0.66l2.42,0l0,13.52q0,3.88 -1.69,5.69a6.75,6.75 0 0 1 -5.17,1.82a15.23,15.23 0 0 1 -2.29,-0.18a16.23,16.23 0 0 1 -2.18,-0.48l0,-2.68l0.16,0.01zm8.62999,-6.58l0,-8.37a8.94,8.94 0 0 0 -1.77,-0.66a6.81,6.81 0 0 0 -1.62,-0.2a3.69,3.69 0 0 0 -3.07,1.43a6.56,6.56 0 0 0 -1.12,4.11a7.17,7.17 0 0 0 0.85,3.86a3,3 0 0 0 2.76,1.32a5.85,5.85 0 0 0 2.05,-0.4a6.47,6.47 0 0 0 1.92,-1.09z",
    fill: "#000000",
    id: "svg_14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m89.954308,228.022995l-3.5,0l-6.44,-8.08l-3.06,0l0,8.08l-2.7,0l0,-20.295l5.24,0a18.78,18.78 0 0 1 2.93,0.19a5.76,5.76 0 0 1 2.25,0.89a5.08,5.08 0 0 1 1.69,1.76a5.29,5.29 0 0 1 0.62,2.68a6,6 0 0 1 -1.13,3.74a6.65,6.65 0 0 1 -3.08,2.23l7.18,8.805zm-5.84,-14.61a3.77,3.77 0 0 0 -0.31,-1.58a2.66,2.66 0 0 0 -1,-1.13a3.74,3.74 0 0 0 -1.34,-0.54a9.65,9.65 0 0 0 -1.9,-0.16l-2.61,0l0,7.73l2.38,0a9.74,9.74 0 0 0 2.09,-0.2a3.2,3.2 0 0 0 1.58,-0.85a3.52,3.52 0 0 0 0.87,-1.37a5.57,5.57 0 0 0 0.24,-1.9z",
    fill: "#000000",
    id: "svg_15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m97.564308,228.382995a7.56,7.56 0 0 1 -5.66,-2.05a8,8 0 0 1 -2,-5.84a8.62,8.62 0 0 1 2,-5.93a6.5,6.5 0 0 1 5.11,-2.2a7.13,7.13 0 0 1 2.51,0.41a5,5 0 0 1 1.91,1.28a5.89,5.89 0 0 1 1.26,2.14a9.54,9.54 0 0 1 0.44,3.09l0,1.39l-10.63,0a5.68,5.68 0 0 0 1.34,4.07a4.86,4.86 0 0 0 3.7,1.41a7.21,7.21 0 0 0 1.66,-0.19a7.8,7.8 0 0 0 1.47,-0.49a10.58,10.58 0 0 0 1.17,-0.61a7,7 0 0 0 0.79,-0.55l0.15,0l0,2.8l-1.12,0.44a12.32,12.32 0 0 1 -1.2,0.42q-0.75,0.21 -1.36,0.31a8.92,8.92 0 0 1 -1.54,0.1zm3,-9.68a7.15,7.15 0 0 0 -0.25,-1.79a3.7,3.7 0 0 0 -0.63,-1.27a2.87,2.87 0 0 0 -1.15,-0.87a5.14,5.14 0 0 0 -3.48,0a4.15,4.15 0 0 0 -1.3,0.89a4.28,4.28 0 0 0 -0.87,1.33a5.74,5.74 0 0 0 -0.38,1.7l8.06,0.01z",
    fill: "#000000",
    id: "svg_16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m114.214308,226.402995l-0.84,0.65a5.94,5.94 0 0 1 -1,0.66a7.66,7.66 0 0 1 -1.32,0.55a6.46,6.46 0 0 1 -1.78,0.19a4.62,4.62 0 0 1 -3.28,-1.35a4.65,4.65 0 0 1 -1,-1.55a5.2,5.2 0 0 1 -0.37,-1.95a5.14,5.14 0 0 1 0.67,-2.7a4.56,4.56 0 0 1 2.12,-1.77a10.52,10.52 0 0 1 3,-0.81q1.75,-0.22 3.77,-0.33l0,-0.49a3.29,3.29 0 0 0 -0.27,-1.45a2,2 0 0 0 -0.76,-0.85001a3,3 0 0 0 -1.2,-0.47a10.21,10.21 0 0 0 -1.46,-0.1a9.85,9.85 0 0 0 -2.09,0.27a14.07,14.07 0 0 0 -2.4,0.77l-0.15,0l0,-2.615q0.71,-0.21 2,-0.45a14.37,14.37 0 0 1 2.62,-0.25a12.15,12.15 0 0 1 2.65,0.25a5.11,5.11 0 0 1 1.94,0.89a3.81,3.81 0 0 1 1.24,1.63a6.41,6.41 0 0 1 0.41,2.43l0,10.43l-2.55,0l0.05,-1.58499zm0,-2.13l0,-4.24l-2.31,0.23a12.45,12.45 0 0 0 -2.26,0.4a4.12,4.12 0 0 0 -1.69,1a2.4,2.4 0 0 0 -0.67,1.81a2.54,2.54 0 0 0 0.74,2a3.11,3.11 0 0 0 2.16,0.67a4.59,4.59 0 0 0 2.2,-0.53a9.52,9.52 0 0 0 1.83,-1.34z",
    fill: "#000000",
    id: "svg_17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m132.084308,228.022995l-2.57,0l0,-1.56q-0.6,0.5 -1,0.83a5.73,5.73 0 0 1 -1,0.6a5.93,5.93 0 0 1 -1.13,0.4a5.79,5.79 0 0 1 -1.37,0.14a5.15,5.15 0 0 1 -2.3,-0.52a4.89,4.89 0 0 1 -1.79,-1.52a7.47,7.47 0 0 1 -1.16,-2.49a12.85,12.85 0 0 1 -0.41,-3.41a10.45,10.45 0 0 1 0.52,-3.47a8.19,8.19 0 0 1 1.43,-2.56a5.94,5.94 0 0 1 2,-1.56a5.66,5.66 0 0 1 2.48,-0.57a7,7 0 0 1 2,0.25a8.76,8.76 0 0 1 1.79,0.79l0,-6.64l2.57,0l-0.06,21.29zm-2.57,-3.71l0,-8.79a8.37,8.37 0 0 0 -1.71,-0.64a7.19,7.19 0 0 0 -1.64,-0.18a3.67,3.67 0 0 0 -3.1,1.48a7,7 0 0 0 -1.12,4.28a8,8 0 0 0 0.86,4.12a3,3 0 0 0 2.76,1.43a5,5 0 0 0 2,-0.46a7.81,7.81 0 0 0 1.95,-1.24z",
    fill: "#000000",
    id: "svg_18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m138.594308,210.217995l-2.92,0l0,-2.66l2.92,0l0,2.66zm-0.18,17.8l-2.57,0l0,-15.28l2.57,0l0,15.28z",
    fill: "#000000",
    id: "svg_19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m154.144308,228.022995l-2.57,0l0,-8.68a17.52,17.52 0 0 0 -0.1,-2a4.16,4.16 0 0 0 -0.39,-1.45a2,2 0 0 0 -0.87,-0.85001a3.46,3.46 0 0 0 -1.53,-0.28a4.37,4.37 0 0 0 -2,0.51a10.14,10.14 0 0 0 -2,1.33l0,11.39l-2.57,0l0,-15.265l2.57,0l0,1.69a10.08,10.08 0 0 1 2.27,-1.57a5.32,5.32 0 0 1 2.36,-0.55a4.39,4.39 0 0 1 3.52,1.48a6.42,6.42 0 0 1 1.27,4.29l0.04,9.95501z",
    fill: "#000000",
    id: "svg_20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m158.294308,230.472995l0.76,0.29q0.51,0.18 1.15,0.35t1.31,0.29a7.34,7.34 0 0 0 1.31,0.11a5.7,5.7 0 0 0 2,-0.31a3,3 0 0 0 1.29,-0.87a3.35,3.35 0 0 0 0.61,-1.3a7.21,7.21 0 0 0 0.18,-1.68l0,-1.34a8,8 0 0 1 -2,1.33a6.33,6.33 0 0 1 -2.5,0.43a5,5 0 0 1 -4.15,-1.94a8.76,8.76 0 0 1 -1.54,-5.57a9.85,9.85 0 0 1 0.53,-3.37a7.71,7.71 0 0 1 1.43,-2.49a5.93,5.93 0 0 1 2,-1.52a5.82,5.82 0 0 1 2.43,-0.53a6.72,6.72 0 0 1 2.05,0.28a8.6,8.6 0 0 1 1.74,0.8l0.15,-0.66l2.42,0l0,13.52q0,3.88 -1.69,5.69a6.75,6.75 0 0 1 -5.17,1.82a15.23,15.23 0 0 1 -2.29,-0.18a16.23,16.23 0 0 1 -2.18,-0.48l0,-2.68l0.16,0.01zm8.63,-6.58l0,-8.37a8.94,8.94 0 0 0 -1.77,-0.66a6.81,6.81 0 0 0 -1.62,-0.2a3.69,3.69 0 0 0 -3.07,1.43a6.56,6.56 0 0 0 -1.12,4.11a7.17,7.17 0 0 0 0.85,3.86a3,3 0 0 0 2.76,1.32a5.85,5.85 0 0 0 2.05,-0.4a6.47,6.47 0 0 0 1.95,-1.1l-0.03,0.01z",
    fill: "#000000",
    id: "svg_21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m97.932808,308.136915l-5.11,20.33l-3,0l-4.14,-16.87l-4,16.87l-3,0l-5.25,-20.33l2.77,0l4.1,16.9l4.07,-16.9l2.74,0l4.11,17.07l4.07,-17.07l2.64,0z",
    fill: "#000000",
    id: "svg_22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m107.752808,315.976915l-0.14,0a2.88,2.88 0 0 0 -0.61,-0.1l-0.77,0a5.08,5.08 0 0 0 -2.06,0.45a6.61,6.61 0 0 0 -1.94,1.34l0,10.83l-2.57,0l0,-15.28l2.57,0l0,2.27a11.71,11.71 0 0 1 2.45,-1.75a4.59,4.59 0 0 1 2,-0.51l0.59,0l0.44,0.06l0.04,2.69z",
    fill: "#000000",
    id: "svg_23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m112.542808,310.666915l-2.92,0l0,-2.66l2.92,0l0,2.66zm-0.18,17.8l-2.57,0l0,-15.25l2.57,0l0,15.25z",
    fill: "#000000",
    id: "svg_24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m120.722808,328.756915a4.39,4.39 0 0 1 -3.28,-1.19a5.22,5.22 0 0 1 -1.17,-3.77l0,-8.45l-1.73,0l0,-2.13l1.73,0l0,-4.38l2.57,0l0,4.38l4.72,0l0,2.13l-4.72,0l0,7.25q0,1.16 0,1.79a3,3 0 0 0 0.31,1.17a1.49,1.49 0 0 0 0.75,0.72a3.41,3.41 0 0 0 1.41,0.24a4,4 0 0 0 1.21,-0.18a7.31,7.31 0 0 0 0.85,-0.31l0.15,0l0,2.31a12.35,12.35 0 0 1 -1.47,0.32a8.94,8.94 0 0 1 -1.33,0.1z",
    fill: "#000000",
    id: "svg_25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m128.262808,310.666915l-2.93,0l0,-2.66l2.92,0l0.01,2.66zm-0.18,17.8l-2.57,0l0,-15.25l2.57,0l0,15.25z",
    fill: "#000000",
    id: "svg_26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m143.812808,328.466915l-2.57,0l0,-8.71a17.52,17.52 0 0 0 -0.1,-2a4.16,4.16 0 0 0 -0.39,-1.45a2,2 0 0 0 -0.87,-0.85a3.46,3.46 0 0 0 -1.53,-0.28a4.37,4.37 0 0 0 -2,0.51a10.14,10.14 0 0 0 -2,1.33l0,11.39l-2.57,0l0,-15.19l2.65,0l0,1.69a10.08,10.08 0 0 1 2.27,-1.57a5.32,5.32 0 0 1 2.36,-0.55a4.39,4.39 0 0 1 3.52,1.48a6.42,6.42 0 0 1 1.27,4.29l-0.04,9.91z",
    fill: "#000000",
    id: "svg_27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m147.952808,330.906915l0.76,0.29q0.51,0.18 1.15,0.35t1.31,0.29a7.34,7.34 0 0 0 1.31,0.11a5.7,5.7 0 0 0 2,-0.31a3,3 0 0 0 1.29,-0.87a3.35,3.35 0 0 0 0.61,-1.3a7.21,7.21 0 0 0 0.18,-1.68l0,-1.34a8,8 0 0 1 -2,1.33a6.33,6.33 0 0 1 -2.5,0.43a5,5 0 0 1 -4.15,-1.94a8.76,8.76 0 0 1 -1.54,-5.57a9.85,9.85 0 0 1 0.53,-3.37a7.71,7.71 0 0 1 1.43,-2.49a5.93,5.93 0 0 1 2,-1.52a5.82,5.82 0 0 1 2.43,-0.53a6.72,6.72 0 0 1 2.05,0.28a8.6,8.6 0 0 1 1.74,0.8l0.15,-0.66l2.42,0l0,13.55q0,3.88 -1.69,5.69a6.75,6.75 0 0 1 -5.17,1.82a15.23,15.23 0 0 1 -2.29,-0.18a16.23,16.23 0 0 1 -2.18,-0.48l0,-2.68l0.16,-0.02zm8.63,-6.58l0,-8.37a8.94,8.94 0 0 0 -1.77,-0.66a6.81,6.81 0 0 0 -1.62,-0.2a3.69,3.69 0 0 0 -3.07,1.43a6.56,6.56 0 0 0 -1.12,4.11a7.17,7.17 0 0 0 0.85,3.86a3,3 0 0 0 2.76,1.32a5.85,5.85 0 0 0 2.05,-0.4a6.47,6.47 0 0 0 1.92,-1.09z",
    fill: "#000000",
    id: "svg_28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m88.294328,411.389315a9.43,9.43 0 0 1 1.8,3.32a14.64,14.64 0 0 1 0.64,4.52a14.81,14.81 0 0 1 -0.63,4.46a9.16,9.16 0 0 1 -1.82,3.34a7.66,7.66 0 0 1 -2.9,2.1a9.6,9.6 0 0 1 -3.65,0.68a9.48,9.48 0 0 1 -3.71,-0.7a7.6,7.6 0 0 1 -2.84,-2.08a9.27,9.27 0 0 1 -1.8,-3.33a14.78,14.78 0 0 1 -0.63,-4.48a14.47,14.47 0 0 1 0.63,-4.51a9.85,9.85 0 0 1 1.81,-3.33a7.67,7.67 0 0 1 2.83,-2.05a9.41,9.41 0 0 1 3.71,-0.7a9.3,9.3 0 0 1 3.74,0.72a7.82,7.82 0 0 1 2.82,2.04zm-0.34,7.87a13.28,13.28 0 0 0 -0.44,-3.58a7.48,7.48 0 0 0 -1.23,-2.58a5.15,5.15 0 0 0 -1.95,-1.58a6.61,6.61 0 0 0 -5.13,0a5.35,5.35 0 0 0 -1.95,1.59a7.4,7.4 0 0 0 -1.24,2.61a13.44,13.44 0 0 0 -0.43,3.55a9.69,9.69 0 0 0 1.68,6.12a5.83,5.83 0 0 0 9,0a9.72,9.72 0 0 0 1.69,-6.13z",
    fill: "#000000",
    id: "svg_29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m101.574328,416.899315l-0.14,0a2.88,2.88 0 0 0 -0.61,-0.1l-0.77,0a5.08,5.08 0 0 0 -2.1,0.46a6.61,6.61 0 0 0 -1.94,1.34l0,10.83l-2.57,0l0,-15.29l2.57,0l0,2.27a11.71,11.71 0 0 1 2.45,-1.75a4.59,4.59 0 0 1 2,-0.51l0.59,0l0.44,0.06l0.08,2.69z",
    fill: "#000000",
    id: "svg_30"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m111.614328,427.759315l-0.84,0.65a5.94,5.94 0 0 1 -1,0.66a7.66,7.66 0 0 1 -1.32,0.55a6.46,6.46 0 0 1 -1.78,0.19a4.62,4.62 0 0 1 -3.28,-1.35a4.65,4.65 0 0 1 -1,-1.55a5.2,5.2 0 0 1 -0.37,-1.95a5.14,5.14 0 0 1 0.67,-2.7a4.56,4.56 0 0 1 2.12,-1.77a10.52,10.52 0 0 1 3,-0.81q1.75,-0.22 3.77,-0.33l0,-0.49a3.29,3.29 0 0 0 -0.27,-1.45a2,2 0 0 0 -0.76,-0.85a3,3 0 0 0 -1.2,-0.42a10.21,10.21 0 0 0 -1.46,-0.1a9.85,9.85 0 0 0 -2.09,0.27a14.07,14.07 0 0 0 -2.4,0.77l-0.15,0l0,-2.61q0.71,-0.21 2,-0.45a14.37,14.37 0 0 1 2.62,-0.25a12.15,12.15 0 0 1 2.65,0.25a5.11,5.11 0 0 1 1.94,0.89a3.81,3.81 0 0 1 1.24,1.63a6.41,6.41 0 0 1 0.41,2.43l0,10.43l-2.55,0l0.05,-1.64zm0,-2.13l0,-4.23l-2.31,0.23a12.45,12.45 0 0 0 -2.26,0.4a4.12,4.12 0 0 0 -1.69,1a2.4,2.4 0 0 0 -0.67,1.81a2.54,2.54 0 0 0 0.74,2a3.11,3.11 0 0 0 2.16,0.67a4.59,4.59 0 0 0 2.2,-0.53a9.52,9.52 0 0 0 1.83,-1.35z",
    fill: "#000000",
    id: "svg_31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m120.364328,429.389315l-2.57,0l0,-21.25l2.57,0l0,21.25z",
    fill: "#000000",
    id: "svg_32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m141.124328,429.759315a9.78,9.78 0 0 1 -3.67,-0.67a7.8,7.8 0 0 1 -2.89,-2a9.12,9.12 0 0 1 -1.88,-3.3a14.17,14.17 0 0 1 -0.67,-4.55a13.77,13.77 0 0 1 0.65,-4.45a9.63,9.63 0 0 1 1.89,-3.3a8.1,8.1 0 0 1 2.88,-2.08a9.33,9.33 0 0 1 3.73,-0.72a11.59,11.59 0 0 1 1.92,0.15a13.36,13.36 0 0 1 1.66,0.38a12.43,12.43 0 0 1 1.34,0.51q0.69,0.31 1.36,0.68l0,3.26l-0.22,0q-0.35,-0.33 -0.91,-0.79a9.16,9.16 0 0 0 -1.37,-0.91a8.81,8.81 0 0 0 -1.69,-0.7a7.41,7.41 0 0 0 -2.12,-0.27a5.77,5.77 0 0 0 -4.49,2.1a7.42,7.42 0 0 0 -1.34,2.61a12.14,12.14 0 0 0 -0.48,3.54a11.37,11.37 0 0 0 0.5,3.6a7.69,7.69 0 0 0 1.38,2.55a5.51,5.51 0 0 0 2,1.52a5.89,5.89 0 0 0 2.43,0.51a7.83,7.83 0 0 0 2.17,-0.29a8.36,8.36 0 0 0 1.78,-0.72a9.34,9.34 0 0 0 1.3,-0.87q0.54,-0.44 0.86,-0.76l0.21,0l0,3.22l-1.26,0.6a11.34,11.34 0 0 1 -1.44,0.56a14.67,14.67 0 0 1 -1.65,0.44a10.49,10.49 0 0 1 -1.98,0.15z",
    fill: "#000000",
    id: "svg_33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m162.314328,421.769315a8.68,8.68 0 0 1 -1.86,5.95a6.28,6.28 0 0 1 -4.94,2.1a6.19,6.19 0 0 1 -5,-2.16a8.83,8.83 0 0 1 -1.82,-5.88a8.65,8.65 0 0 1 1.88,-5.94a6.85,6.85 0 0 1 9.89,0a8.71,8.71 0 0 1 1.85,5.93zm-2.65,0a7.34,7.34 0 0 0 -1.08,-4.4a4,4 0 0 0 -6.16,0a9.37,9.37 0 0 0 0,8.75a4,4 0 0 0 6.16,0a7.29,7.29 0 0 0 1.08,-4.35z",
    fill: "#000000",
    id: "svg_34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m182.324328,429.389315l0,-8.82q0,-1.05 -0.08,-1.95a3.92,3.92 0 0 0 -0.34,-1.4a1.76,1.76 0 0 0 -0.78,-0.81a3,3 0 0 0 -1.37,-0.26a3.64,3.64 0 0 0 -1.7,0.48a8.92,8.92 0 0 0 -1.88,1.4l0,11.31l-2.57,0l0,-8.82q0,-1.05 -0.08,-1.95a3.9,3.9 0 0 0 -0.34,-1.4a1.75,1.75 0 0 0 -0.78,-0.81a3,3 0 0 0 -1.37,-0.26a3.55,3.55 0 0 0 -1.75,0.52a9.37,9.37 0 0 0 -1.77,1.32l0,11.39l-2.57,0l0,-15.19l2.57,0l0,1.69a9.26,9.26 0 0 1 2,-1.56a4.39,4.39 0 0 1 2.18,-0.55a4.64,4.64 0 0 1 2.4,0.61a3.85,3.85 0 0 1 1.59,2a10.25,10.25 0 0 1 2.27,-2a4.56,4.56 0 0 1 2.4,-0.67a5,5 0 0 1 1.79,0.31a3.53,3.53 0 0 1 1.41,1a4.84,4.84 0 0 1 0.95,1.73a8.64,8.64 0 0 1 0.33,2.61l0,10l-2.51,0.08z",
    fill: "#000000",
    id: "svg_35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m192.514328,429.389315l-3.26,0l0,-3.89l3.26,0l0,3.89z",
    fill: "#000000",
    id: "svg_36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m89.194338,529.344765l-3,0l-9,-17.53l0,17.53l-2.54,0l0,-20.32l3.84,0l8.18,16.1l0,-16.1l2.53,0l-0.01,20.32z",
    fill: "#000000",
    id: "svg_37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m105.044338,529.344765l-2.57,0l0,-1.69a11.15,11.15 0 0 1 -2.25,1.58a5.19,5.19 0 0 1 -2.38,0.54a5.33,5.33 0 0 1 -1.88,-0.33a3.94,3.94 0 0 1 -1.54,-1a4.89,4.89 0 0 1 -1,-1.79a8.3,8.3 0 0 1 -0.36,-2.62l0,-9.9l2.57,0l0,8.67a18.69,18.69 0 0 0 0.09,2a3.91,3.91 0 0 0 0.4,1.4a2,2 0 0 0 0.85,0.86a3.5,3.5 0 0 0 1.55,0.27a4.51,4.51 0 0 0 2,-0.53a9.2,9.2 0 0 0 2,-1.31l0,-11.4l2.57,0l-0.05,15.25z",
    fill: "#000000",
    id: "svg_38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m126.074338,529.344765l0,-8.82q0,-1.05 -0.08,-1.95a3.92,3.92 0 0 0 -0.34,-1.4a1.76,1.76 0 0 0 -0.78,-0.81a3,3 0 0 0 -1.37,-0.26a3.64,3.64 0 0 0 -1.7,0.48a8.92,8.92 0 0 0 -1.88,1.4q0,0.23 0,0.55t0,0.76l0,10l-2.57,0l0,-8.82q0,-1.05 -0.08,-1.95a3.9,3.9 0 0 0 -0.34,-1.4a1.75,1.75 0 0 0 -0.78,-0.81a3,3 0 0 0 -1.37,-0.26a3.55,3.55 0 0 0 -1.75,0.52a9.37,9.37 0 0 0 -1.77,1.32l0,11.39l-2.57,0l0,-15.19l2.57,0l0,1.71a9.26,9.26 0 0 1 2,-1.56a4.39,4.39 0 0 1 2.18,-0.55a4.64,4.64 0 0 1 2.4,0.61a3.85,3.85 0 0 1 1.59,2a10.25,10.25 0 0 1 2.27,-2a4.56,4.56 0 0 1 2.4,-0.67a5,5 0 0 1 1.79,0.31a3.53,3.53 0 0 1 1.41,1a4.84,4.84 0 0 1 0.95,1.73a8.64,8.64 0 0 1 0.33,2.61l0,10l-2.51,0.06z",
    fill: "#000000",
    id: "svg_39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m138.894338,529.704765a7.56,7.56 0 0 1 -5.66,-2.05a8,8 0 0 1 -2,-5.84a8.62,8.62 0 0 1 2,-5.93a6.5,6.5 0 0 1 5.11,-2.2a7.13,7.13 0 0 1 2.51,0.41a5,5 0 0 1 1.91,1.28a5.89,5.89 0 0 1 1.26,2.14a9.54,9.54 0 0 1 0.44,3.09l0,1.39l-10.64,0a5.68,5.68 0 0 0 1.34,4.07a4.86,4.86 0 0 0 3.7,1.41a7.19,7.19 0 0 0 1.66,-0.19a7.77,7.77 0 0 0 1.43,-0.48a10.76,10.76 0 0 0 1.17,-0.61a7,7 0 0 0 0.79,-0.55l0.15,0l0,2.8l-1.12,0.44a12.44,12.44 0 0 1 -1.2,0.42q-0.75,0.21 -1.36,0.31a9,9 0 0 1 -1.49,0.09zm3,-9.68a7.15,7.15 0 0 0 -0.25,-1.79a3.7,3.7 0 0 0 -0.63,-1.27a2.87,2.87 0 0 0 -1.15,-0.87a5.14,5.14 0 0 0 -3.48,0a4.15,4.15 0 0 0 -1.3,0.89a4.28,4.28 0 0 0 -0.87,1.33a5.74,5.74 0 0 0 -0.38,1.7l8.06,0.01z",
    fill: "#000000",
    id: "svg_40"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m155.094338,516.854765l-0.14,0a2.88,2.88 0 0 0 -0.61,-0.1l-0.77,0a5.08,5.08 0 0 0 -2.06,0.45a6.61,6.61 0 0 0 -1.94,1.34l0,10.83l-2.57,0l0,-15.28l2.57,0l0,2.27a11.71,11.71 0 0 1 2.45,-1.75a4.59,4.59 0 0 1 2,-0.51l0.59,0l0.44,0.06l0.04,2.69z",
    fill: "#000000",
    id: "svg_41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m165.134338,527.724765l-0.84,0.65a5.86,5.86 0 0 1 -1,0.66a7.66,7.66 0 0 1 -1.32,0.55a6.49,6.49 0 0 1 -1.78,0.19a4.61,4.61 0 0 1 -3.28,-1.35a4.64,4.64 0 0 1 -1,-1.55a5.2,5.2 0 0 1 -0.37,-1.95a5.14,5.14 0 0 1 0.67,-2.7a4.56,4.56 0 0 1 2.12,-1.77a10.52,10.52 0 0 1 3,-0.81q1.75,-0.22 3.77,-0.33l0,-0.51a3.29,3.29 0 0 0 -0.27,-1.45a2,2 0 0 0 -0.76,-0.85a3,3 0 0 0 -1.2,-0.42a10.21,10.21 0 0 0 -1.46,-0.1a9.85,9.85 0 0 0 -2.09,0.27a14.07,14.07 0 0 0 -2.4,0.77l-0.15,0l0,-2.61q0.71,-0.21 2,-0.45a14.37,14.37 0 0 1 2.62,-0.25a12.15,12.15 0 0 1 2.65,0.25a5.11,5.11 0 0 1 1.94,0.89a3.81,3.81 0 0 1 1.24,1.63a6.41,6.41 0 0 1 0.41,2.43l0,10.43l-2.55,0l0.05,-1.62zm0,-2.13l0,-4.23l-2.31,0.23a12.45,12.45 0 0 0 -2.26,0.4a4.12,4.12 0 0 0 -1.69,1a2.4,2.4 0 0 0 -0.67,1.81a2.54,2.54 0 0 0 0.74,2a3.11,3.11 0 0 0 2.16,0.67a4.59,4.59 0 0 0 2.2,-0.53a9.54,9.54 0 0 0 1.83,-1.35z",
    fill: "#000000",
    id: "svg_42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m177.324338,529.694765a8.24,8.24 0 0 1 -2.88,-0.49a5.92,5.92 0 0 1 -2.25,-1.47a6.69,6.69 0 0 1 -1.46,-2.48a10.74,10.74 0 0 1 -0.52,-3.52a10,10 0 0 1 0.54,-3.47a7.48,7.48 0 0 1 1.44,-2.46a6,6 0 0 1 2.25,-1.54a7.68,7.68 0 0 1 2.89,-0.54a8.28,8.28 0 0 1 2.42,0.35a13,13 0 0 1 2.08,0.82l0,2.91l-0.15,0c-0.18,-0.15 -0.42,-0.33 -0.7,-0.53a9.11,9.11 0 0 0 -1,-0.61a6.88,6.88 0 0 0 -1.26,-0.48a5.1,5.1 0 0 0 -1.39,-0.21a3.9,3.9 0 0 0 -3.2,1.51a6.67,6.67 0 0 0 -1.21,4.27a6.74,6.74 0 0 0 1.17,4.21a3.87,3.87 0 0 0 3.24,1.51a5.68,5.68 0 0 0 2.39,-0.52a7.46,7.46 0 0 0 2,-1.34l0.15,0l0,2.88l-1,0.43a7.23,7.23 0 0 1 -1,0.38c-0.44,0.13 -0.83,0.23 -1.17,0.29a7.12,7.12 0 0 1 -1.38,0.1z",
    fill: "#000000",
    id: "svg_43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m196.204338,514.094765l-8.25,20.88l-2.74,0l2.73,-6.36l-5.54,-14.51l2.77,0l4.16,11.29l4.15,-11.29l2.72,-0.01z",
    fill: "#000000",
    id: "svg_44"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.771159172058105,129.56170654296875 27.771159172058105,97.05169677734375 60.29117488861084,97.05169677734375 60.29117488861084,129.56170654296875 ",
    className: "cls-3",
    fill: "#ffc000",
    id: "svg_45"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.771159172058105,133.69171142578125 27.771159172058105,129.19171142578125 60.29117488861084,129.19171142578125 60.29117488861084,133.69171142578125 ",
    className: "cls-4",
    fill: "#d2a000",
    id: "svg_46"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,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",
    height: 26.55,
    width: 25.6,
    y: 100.481912,
    x: 31.227803,
    className: "cls-5",
    id: "svg_47"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.99766445159912,229.14779663085938 27.99766445159912,196.6278076171875 60.51767635345459,196.6278076171875 60.51767635345459,229.14779663085938 ",
    className: "cls-6",
    fill: "#ff3399",
    id: "svg_48"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.99766445159912,233.27780151367188 27.99766445159912,228.77780151367188 60.51767635345459,228.77780151367188 60.51767635345459,233.27780151367188 ",
    className: "cls-7",
    fill: "#d6009e",
    id: "svg_49"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,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",
    height: 19.88,
    width: 20.93,
    y: 204.507991,
    x: 34.20431,
    className: "cls-5",
    id: "svg_50"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28.47615909576416,329.33160400390625 28.47615909576416,296.8116149902344 60.99617671966553,296.8116149902344 60.99617671966553,329.33160400390625 ",
    className: "cls-8",
    fill: "#00b0f0",
    id: "svg_51"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28.47615909576416,333.46160888671875 28.47615909576416,328.96160888671875 60.99617671966553,328.96160888671875 60.99617671966553,333.46160888671875 ",
    className: "cls-9",
    fill: "#0085b4",
    id: "svg_52"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUcAAAFHCAYAAAAySY5rAAAACXBIWXMAAKwXAACsFwGhXL0PAAAWcklEQVR4Xu3da6xtV1nGcQwYP6gRNEZNQEkUrVIUqSjxEirEcBUtioBUBBGx4CVCA1YNF1GREBUv0WiEKN4iRlG5ysVWIIi0tGBbqFwKIphya3vOPqe1lb1e3y37tKeze+9njDXnGOMdc/yf5Pelec5eY82x1tu191przjuY2R0AALclCwAwIlkAgBHJAgCMSBYAYESyAAAjkgUAGJEsAMCIZAEARiQLADAiWQCAEckCAIxIFgBgRLIAACOSBQD17e7u/tqU+jdYliwAKMsH35tsi+z/O/nzsR1ZAFDMklG3hUyyAGA5Ozs797SCOXbs2D0sYR3QZAHAMvzX4GusQvx23m4J68HRZAHAIlpErQlHkAUAs7XMHU2vDweQBQCzRMjnml4nJmQBwNbCZLPZfI3p9eI0sgBgK+HiA3LvnXK1buyTBQDZwsYH5F1Nrx/GcASW1kPUfYAxHIGl9RB1H2AMR2BJPeUupu/P0GQBQJLustlsvsH0/RqWLACQug3vYB9OFgAcqfv4gPxS0/dzOLIA4FBrirqvw5EFAAdaXfwV5N1M3+9hyAKAW+3s7DzAVhwfkN9oCcdhBLIA4LOuv/76B9kYOcMSjsfayQIAu8PJkyfva2PlCyzhuKyZLACwO9uYuZPpY7NasgCM7LrrrruPDZzNZjPsNWlkARjVQH9jVLm3JRyvtZEFYEQ7OzvfY+SW+CvIr7aE47YmsgCMxgfjvYwcFHns1kQWgJEcP35876t05PAMczYfWQBG4YPxO43I+K/YZ1rC8eydLAAj8Cf8w4zkZPVv0sgCsHY+GB9oJDtr/y62LABrtv8uLNk+8hj3ShaAtdr/gDOZmbW+gpQFYI38Cc3nGBeMH89vtoTj3hNZANbGn8gPN7J41na6M1kA1sSfwN9lpFj8+H6JJexDD2QBWAt/4n6FkeI5duzYf1nCfkQnC8Aa+GAc+uw6tXPy5MkLLWFfIpMFoHc+GB9qpHpuuOGGf7SE/YlKFoDe+XD8DiNN4q8g32gJexSRLABrsP9ZPNIgOzs7V1vCHkUjC8Ba7F+8njTIiRMnrrKEPYpEFoA18QH5rUaaxH/FfoMl7FEUsgCs0NlGmsQH5KtN708IsgCs1FlGmmRnZ+dtpvenOVkAVuyLjDTJ8ePHP216f5qSBWDl7m6kSXxAXmp6f5qRBWDtNpvNtxtpkpMnT77OEvaoBVkARsAJKdrFB+Q/WcIe1SYLwCh8QH69kSY5ceLEuy1hj2qSBWBApEF2d3evNb031cgCEMxZ/iQqfUqsM4w0ie/tv5renypkAYjCf+19hN2aS1R/Jq5h3Si+z/czvT/FyQIQgT9hHmm3T9EBuf8kJW3S/LrYsgC05kPq/nZIKvyK/ZVGWkXtTVGyALSUcflU+bO25Wv4fCOtIvenFFkAGjrbEuOvIN9v+udtzQfkNxlpkb3HgNyfEmQBaMGH0Q9aZnxAXmwJP3sG3qRpE7UvRcgCUJsPxnNsy/iALPph4v2L15OK8WN+gSXszdJkAahpoZPRXm8JtzXDnY3UjtqTxckCUMuSX9/zV5A3WMJtbsvX+mVGambvf0hyX5YkC0AtDEdyRBiOGJMPm4fYwvEBeaUl3Pa2fM3fYqRm5J4sSRaA0nzIPNrKpfS3aDgXZL3I/ViSLAAl+XD5XiscfwX5PktYywycqKJO1D4sShaAUnwwnmmV4gNyYwlrmokUzP4JidUeLEYWgBJa/L3OB+SnLGFtM9zdSLEwHLF6h5xhp0p8QP67JaxxWwt9TpMcHrkHS5EFYEk+PB5rjeMD8jJLWOu2/D7e10ipyOO/FFkAluJD48EWJJzqrNuo474YWQCW4IPxXhYzcu0zfI6RpaOO+WJkAZjLB+N3W9D4K8iPWMJ9mIGP+SwbdbwXIwvAHD4YH2PB4wPyXZZwX7blx+DbjMyO79NLLeF4L0UWgG0V/ubLovEn3uWWcJ9muLeRWeGjPFiLs62z+IC8zvT9muMuRuZEHd9FyQKwhd5fJan7tzV/9fOFRraNPL5LkgUghz/5H2adx19BfsAS7uu2Ar9zHz3y2C5JFoBU/qQ/11aSCm/S8E2ajPjxOt8SjuuSZAFI9ChbWSpc0fDrjKRGHs+lyQKgrPmjKj4gdy3hGMzAB8V1Xm76OC5OFoCjjPA9Yp+PJyzhWGyLSy7IyGNYgiwAR1jdr9KHxQfke00fj61tuOTrgbnppps+bAnHrwRZAA7iT+bH22Apfbozd5aRadQxK0YWgCkfjOdYoJw4cWLv3cyvPUX158QH5Ect4Rhty9d/NyOnckdLOGalyAJwuoB/YzxsnUf+owUij9VMQ8f370Gmj1FRsgCc4g/YB1isqDUXi7+C/ITp25/j7jZobr755qIfwk8lC8CegB/wlms+/J8ukwrXxb6PDZbS307KIQtAwDdf5Jr3FY8/md9jeh1bG+mrhn4sdyzhmNQiCxibPzkfarEi13yaKvEn9bWm1zLHKGfzUcehKlnAuHww3s9iRa75NC2+eaLWNMedbKXx/7l83PT9r04WMCYfjI+wWJFrnqie0hftKv0xpRbxY3aVJdz3FmQB4/En4RMtVuSaJ5rFn+xXmF7f1tb0Jo0fqw9Zwn1uRRYwFn/y/YjFilzzRPOUfsd1Da8gK5zQYzZZwDg28a4SKNc8ESb+3P9f0+ud447Wd9T9a04WMIbNZy9eFClyzRPh4gPyM6bXPcedrbP4MflP0/crBFnA+m3iXT5VrnkibHwYfND0+rfme3dP6ySlz2y0NFnAuvmT68ctVuSaJ8Kn9DdprIMLmpU+YUcJsoD18sH4WIsVueaJblJ6OHRwNh95H6KRBayTP5nub7Ei1zzRa9T9mitUSp9FvSRZwPr4YHygxYpc80S38WFx3PT9m+PLLUj8vr7P9HrDkgWszhMsVtR6p7pP6aER4WQVvb35chBZwHr4k+bJFityzROrSemvzbV8F9vv2yctYY3RyQLWwZ8sP2CxItc8sbqUPpuP7/kXW5vItfVAFrAKZ1usqPVOrT3q/s9VJVHPrrMtWUD3vt9iRa13avUpfckFfwX5VVY4pU/624IsoGs/YbGi1js1TCr8DbLYmzSl32BqRRbQJ7750l8qfNXwHrZwfM0nLeG2eyQL6I8/CR5usSLXPDFsfNjcbPr4zLH0GcXV7XVLFtAXPuC9mqjjtDV/jHyezYwP8Q9bwm31TBbQF4bjaqKO09YYjmlkAf3wB/3jLFbkmifIfnbLX49m678/+tout4Tb6J0soA/+YD/PYkWueYJMUuEd7DMtM76mqy3hZ6+BLCA+Loi13vgw+pjp47c1f+zc1fIif+ZayAJi8wf3gy1W5JonSFrUcZzryKz5IzuHkQXE5YPxIRYrcs0TJDEVPuJz6PVoSv96H5UsICYfjE+yWJFrniCZ2S1/neczbJJR3nw5iCwgHh+MT7NYkWueIFvGh9X7TR/fOW4ZkKUv7RCdLCAWH4znWqzINU+Qmal4qjPZXTNZQBy8+UImUccbM8gCYvDB+EiLFbnmCbJ8rjd93LElWUB7PhifarEi1zxBCsV/xf6A6eOPLcgC2vLB+FMWK3LNE6RwKryLPSRZQFOPslhR650ileID8ibT+4EMsoA2/BXjQy1W5JonSJuofUEiWUB9Phgfb7Ei1zxBGmVtF7lqSRZQlw/Gn7VYkWueII3DmzTLkAXUw2nHyFIpfTafEcgC6vDBeI7FilzzBIkZtW84hCygPB+M32exItc8QWJH7R8OIAsoywfjUyxW5JonSPCMfgKJbckCyvHB+HSLFbnmCdJBSl8Pe61kAWX4YHyyxYpc8wTpJ2ovcQBZwPJ484XUCJ95nEcWsDi+EkiKxwfju03vJY4gC1iOv2L8GYsVueYJ0kF8MF5mei8hyAKWwZsvpEZ4Z3o5soD5fDD+qMWKXPME6SdqL5FIFjAPb76QGvFXjFeb3ktkkAXM8gSLFbXeKdJHLjG9l8gkC9iOv2I832JFrnmCdBDelS5HFpCPN19Ijfhg/LTpvcSWZAF5fDD+sMWKXPME6SA+GP/H9F5iBllAOh+MP2SxItc8QTqID8YrTe8lZpIFpPHB+DSLFbnmCdJBfDC+w/ReYgGygCQ/b7Gi1jtFOogPxveY3kssRBZwNL4SSGqES6/WJws4nA/Gx1isyDVPkA7C2XXakAUcjuFIaoTh2IYs4GA+GB9nsSLXPEE6iA/GS03vJQqQBdweH/ImNcI7023JAm7LB+MFFityzROkg/hg/IDpvURBsoBb+WA8z2JFrnmC9BO1lyhMFvBZfC2Q1AhXCoxDFvD/g/HHLFbkmidIB/HB+G+m9xKVyMLo+BsjqREfjBeb3ktUJAsjYzCSGvHB+DHTe4nKZGFUPhifZLEi1zxBOghfC4xLFkbkg/FcixW55gnSQXwwXmF6L9GILIyI4UhqhOEYmyyMhrPskBrxwfg203uJhmRhJD4Yn22xItc8QTqID8bLTO8lGpOFUfhgfKbFilzzBOkj15veSwQgCyPwwfhEixW55gnSQfwV4ydM7yWCkIW1YzCSSrnE9F4iEFlYMx+Mz7JYkWueIB3EXzG+1fReIhhZWLHnWqyo9U6RDsJlVPslC2vEyWpJjfhg/IzpvURQsrA2/I2R1AinHuufLKyJD8aftFiRa54gHYQPeK+DLKwFH/AmNcJgXA9ZWAN/wD7PYkWueYJ0EH6VXhdZ6J2/YvxpixW55gnSQXww3mx6L9ERWegZlzcgNeKD8XLTe4nOyEKvfDD+nMWKXPME6SA+GN9sei/RIVnokT9gf8ViRa55gnQQf5y93fReolOy0Bt/xfgcixW55gnSQXww/rfpvUTHZKEnPhifarEi1zxBOogPxk+a3kt0ThZ64YPxKRYrcs0TpIP4YHyH6b3ECshCD3ww/qLFilzzBOkjF5neS6yELETn/yd/gcWKXPME6SD+OHun6b3EishCZP6K8ZcsVuSaJ0gH8cF43PReYmVkISofjOdZrMg1T5AOwlcCxyULEfGVQFIjPhjfYnovsVKyEI0/YJ9vsSLXPEH6yEWm9xIrJguR+GB8ocWKXPME6SD+OLvC9F5i5WQhCq4rTWqESxvgFFmIgG++kBrxwfhu03uJQchCaz4Yz7dYkWueIB3EB+M/m95LDEQWWuJvjKRGOO0YDiILDf26BcrOzk7utUFIB+FzjDiMLLTgv0o/w+JFrvs0pINwdh0cRRZqC/gB71ORa99HOggnqoUiCzUFPFHt6ZHrP/yfkkjxwfgG03uJwclCLf6A/U0LHF/fdXb0fSAdhOtKI5Us1OAP2F+1DnLjjTdeawffB9JB/HF2jSU8HoE9slBawKsEkhWGd6WRSxZK8sH4dCOkfC6yhMcjcDpZKCjU5xjJOuOvGF9v+rEI3I4slOAP2N8yQsrnEkt4PAIHkYUCnmuEFI7/D/iE6ccicChZWBJvvpAa8cH4Lkt4PAJHkYWl+GC8wAgpHP7GiKXIwhIC/Y2xm89UkvzwzRcsSRbm8gfsiy1GTl/Ti1SZ9BUubYClycIcEa4r7U+aG+yAtfl/f9mR/5B0E9/LT1nC4xHIIQvbinAGb/V9aAZk/+G70ihFFrbhD9hfthhJWetvHP7PSeT43r3WEvYY2IYsbIPhSGqE4YiSZCGXP2B/z2JErvWUQMOcJMb37EJL2FtgW7KQI9JHdnIFWjsR8b262hL2FJhDFjI1jT9pjple46F4gyZ+OPUYapGFTM0ydzCe4j/nJbf74SREfG/eZAl7CCxBFjK1jFpbMr5FEy++J6+2hL0DliILmVpFrSsbb9LEie/FWy1hz4AlyUKmFlFr2po/KX/fSNP4HnzCEvYKWJosZKoWf9IcdrGrpf2JkSbxPb7M9P4ARchCpirZrXwiU7+93zVSNXzAG63JQqZaUetY3GazeY6RKuHNF0QgC5lqRK2hGH/SPt9I0fgxvtgS9gIoTRYylY66/eL8yfuHRorEj+01lrAHQA2ykKl01O1X4U/iPzayaPi4DqKRhUylo26/Gn8yv9DIIvFj+UpLOOZATbKQqXTU7VcV4UznvccH4+ss4VgDtclCptJRt1+dP7lfYGSr7HLdFwQmC5lKR91+E/4k/yMjWeHsOohOFjKVjrr9ZvzJ/gdGkrLLJVTRAVnIVDrq9pvyJ/3zjBwZP0Z/bwnHEmhNFjKVjrr95jabzS8YOTA+GN9oCccQiEAWMpWOuv0QfAi8yMht4sfkQ5Zw7IAoZCFT6ajbD4Nv0twazq6DHslCptJRtx/KLhft2huMr7KEYwVEIwuZSkfdfjgj/w3SB+MrLOEYARHJQqbSUbcf0ogD0gfjmy3h2ABRyUKm0lG3H5YPixfbIPH7+mFLOCZAZLKQqXTU7Ye2O8A1afw+vsUSjgUQnSxkKh11++Htrviyr37f/s4SjgHQA1nIVDrq9ruw2WyeaSuLD8Z/sIT7DvRCFjKVjrr9bviAfLatJD4Y32EJ9xnoiSxkKh11+13xofI71nn8PrzfEu4r0BtZyFQ0/mrr0aX4jz/D9P1bnA+X37ZOw4lqsWaykKnb+IB8lun7V0SPZxT3wfg3lnDfgF7JQqZu03I47vHbf4Z1Er4SiBHIQqZu03o47unhfJC+xist4b4AvZOFTN0mwnDcE/lvkL62Sy3hPgBrIAuZuk2U4bgn4vkg+RwjRiMLmbpNpOG4x9dzvsXJyy1hzcCayEKmbhNtOO5rHn/F+HrT6wRWRxYydZuAw7F5fDC+1/Q6gVWShUzdJtJw9KF0zBrH1/AvlrBWYK1kIVO3iTIcfSj9h7UPf2PE8GQhU7eJMBx9MF5l7cNgBIzheEtaD0cfjNda4/CrNHArWcjUbRoPx+bxwXi56XUCw5CFTN2m1XD0ofRxaxxfw2ssYa3ASGQhU7dpMRz3PyrTNL6Gv7SEtQKjkYVM3YbhCOB0spCp29Qejj6UPmiN42v4W0tYKzAiWcjUbWoORx9KN1vj+BoutoS1AqOShUzdpuJwbB5OPQZospCp29QYjj6UPmKNw6/SQBpZyNRtSg/HIG++/LklrBUAw/GWlByOPpQ+ao3DyWqBPLKQqdsUHI7N44PxnabXCeA0spCp25QYjj6UbrL2ucgS1grgtmQhEwkUPuANbE8WMpEg8cH4Z6b3C8AhZCETCRAfjK81vVcAjiALmUj7XGJ6nwAIspCJNIy/YnyV6T0CkEAWMpFG8cH4p6b3B0AiWchEGsQH41+Y3hsAGWQhE6kcrvsClCELmUjF+GB8u+k9AbAFWchE6oVLqAIFyUImUiH+ivGlpvcCwAyykIkUjg/Gvza9DwBmkoVMpGB8ML7V9B4AWIAsZCKF4oPxQtPHH8BCZCETKRAfjC8zfewBLEgWMpGF44PxJaaPO4CFyUImsmB8ML7C9DEHUIAsZCILxQfjW0wfbwCFyEImskB8ML7S9LEGUJAsZCIzw98YgRhkIROZEb75AsQhC5nIlvHB+BrTxxdAJbKQiWyXi0wfWwAVyUImkhl/xfhXpo8rgMpkAQBGJAsAMCJZAIARyQIAjEgWAGBEsgAAI5IFABiRLADAiGQBAEYkCwAwIlkAgBHJAgCMSBYAYESyAAAjkgUAGJEsAMCIZAEARiQLADAiWQCAEckCAIxIFgBgRLIAACOSBQAYkSwAwIhkAQBG9H8jjsFjG6xlhAAAAABJRU5ErkJggg==",
    height: 21.63,
    width: 18.54,
    y: 303.846917,
    x: 34.792804,
    className: "cls-5",
    id: "svg_53"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.997679710388184,430.00408935546875 27.997679710388184,397.48406982421875 60.51769161224365,397.48406982421875 60.51769161224365,430.00408935546875 ",
    className: "cls-10",
    fill: "#7030a0",
    id: "svg_54"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.997679710388184,434.13409423828125 27.997679710388184,429.63409423828125 60.51769161224365,429.63409423828125 60.51769161224365,434.13409423828125 ",
    className: "cls-11",
    fill: "#532476",
    id: "svg_55"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,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",
    height: 22.12,
    width: 22.12,
    y: 403.919317,
    x: 33.754324,
    className: "cls-5",
    id: "svg_56"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.99769115447998,529.7095947265625 27.99769115447998,497.1895446777344 60.517706871032715,497.1895446777344 60.517706871032715,529.7095947265625 ",
    className: "cls-12",
    fill: "#00b050",
    id: "svg_57"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.99769115447998,533.839599609375 27.99769115447998,529.339599609375 60.517706871032715,529.339599609375 60.517706871032715,533.839599609375 ",
    className: "cls-13",
    fill: "#007434",
    id: "svg_58"
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,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",
    height: 24.01,
    width: 16.03,
    y: 502.784766,
    x: 36.764338,
    className: "cls-5",
    id: "svg_59"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DDDDDD",
    strokeWidth: 0,
    strokeOpacity: "null",
    x: 216.944001,
    y: 98.099892,
    width: 599.434812,
    height: 35,
    id: "svg_77",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    x1: 217.01391,
    y1: 74.724792,
    x2: 217.01391,
    y2: 133.034311,
    id: "svg_80",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 813.209277,
    y: 71.73813,
    id: "svg_86",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 333.364801,
    y: 70.126738,
    id: "svg_87",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 453.460503,
    y: 71.801601,
    id: "svg_88",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 573.496339,
    y: 71.73813,
    id: "svg_89",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 693.220169,
    y: 71.536327,
    id: "svg_90",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "4"), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 816.791142,
    y1: 74.746984,
    x2: 816.791142,
    y2: 133.056503,
    id: "svg_91",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 336.987323,
    y1: 74.428519,
    x2: 336.987323,
    y2: 132.738038,
    id: "svg_92",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 456.610774,
    y1: 74.587752,
    x2: 456.610774,
    y2: 132.897271,
    id: "svg_93",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 576.929212,
    y1: 74.587745,
    x2: 576.929212,
    y2: 132.897264,
    id: "svg_94",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 696.727028,
    y1: 74.587745,
    x2: 696.727028,
    y2: 132.897264,
    id: "svg_95",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 756.181979,
    y: 69.067865,
    width: 0.957121,
    height: 64.103537,
    id: "svg_96",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 276.404911,
    y: 69.227101,
    width: 0.957121,
    height: 64.103537,
    id: "svg_97",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 396.309368,
    y: 69.227101,
    width: 0.957121,
    height: 64.103537,
    id: "svg_98",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 516.213828,
    y: 68.908629,
    width: 0.957121,
    height: 64.103537,
    id: "svg_99",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 636.436757,
    y: 69.227101,
    width: 0.957121,
    height: 64.103537,
    id: "svg_100",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DDDDDD",
    strokeWidth: 0,
    strokeOpacity: "null",
    x: 216.944001,
    y: 198.099889,
    width: 599.434812,
    height: 35,
    id: "svg_1",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    x1: 217.01391,
    y1: 174.724789,
    x2: 217.01391,
    y2: 233.034308,
    id: "svg_2",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 813.209277,
    y: 171.738127,
    id: "svg_3",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 333.364801,
    y: 170.126735,
    id: "svg_4",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 453.460503,
    y: 171.801598,
    id: "svg_5",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 573.496339,
    y: 171.738127,
    id: "svg_6",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 693.220169,
    y: 171.536324,
    id: "svg_60",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "4"), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 816.791142,
    y1: 174.746981,
    x2: 816.791142,
    y2: 233.0565,
    id: "svg_61",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 336.987323,
    y1: 174.428516,
    x2: 336.987323,
    y2: 232.738035,
    id: "svg_62",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 456.610774,
    y1: 174.587749,
    x2: 456.610774,
    y2: 232.897268,
    id: "svg_63",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 576.929212,
    y1: 174.587742,
    x2: 576.929212,
    y2: 232.897261,
    id: "svg_64",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 696.727028,
    y1: 174.587742,
    x2: 696.727028,
    y2: 232.897261,
    id: "svg_65",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 756.181979,
    y: 169.067862,
    width: 0.957121,
    height: 64.103537,
    id: "svg_66",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 276.404911,
    y: 169.227098,
    width: 0.957121,
    height: 64.103537,
    id: "svg_67",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 396.309368,
    y: 169.227098,
    width: 0.957121,
    height: 64.103537,
    id: "svg_68",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 516.213828,
    y: 168.908626,
    width: 0.957121,
    height: 64.103537,
    id: "svg_69",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 636.436757,
    y: 169.227098,
    width: 0.957121,
    height: 64.103537,
    id: "svg_70",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DDDDDD",
    strokeWidth: 0,
    strokeOpacity: "null",
    x: 216.944001,
    y: 297.699891,
    width: 599.434812,
    height: 35,
    id: "svg_71",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    x1: 217.01391,
    y1: 274.324791,
    x2: 217.01391,
    y2: 332.63431,
    id: "svg_72",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 813.209277,
    y: 271.338129,
    id: "svg_73",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 333.364801,
    y: 269.726737,
    id: "svg_74",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 453.460503,
    y: 271.4016,
    id: "svg_75",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 573.496339,
    y: 271.338129,
    id: "svg_76",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 693.220169,
    y: 271.136326,
    id: "svg_78",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "4"), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 816.791142,
    y1: 274.346983,
    x2: 816.791142,
    y2: 332.656502,
    id: "svg_79",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 336.987323,
    y1: 274.028518,
    x2: 336.987323,
    y2: 332.338037,
    id: "svg_81",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 456.610774,
    y1: 274.187751,
    x2: 456.610774,
    y2: 332.49727,
    id: "svg_82",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 576.929212,
    y1: 274.187744,
    x2: 576.929212,
    y2: 332.497263,
    id: "svg_83",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 696.727028,
    y1: 274.187744,
    x2: 696.727028,
    y2: 332.497263,
    id: "svg_84",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 756.181979,
    y: 268.667864,
    width: 0.957121,
    height: 64.103537,
    id: "svg_85",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 276.404911,
    y: 268.8271,
    width: 0.957121,
    height: 64.103537,
    id: "svg_101",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 396.309368,
    y: 268.8271,
    width: 0.957121,
    height: 64.103537,
    id: "svg_102",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 516.213828,
    y: 268.508628,
    width: 0.957121,
    height: 64.103537,
    id: "svg_103",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 636.436757,
    y: 268.8271,
    width: 0.957121,
    height: 64.103537,
    id: "svg_104",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DDDDDD",
    strokeWidth: 0,
    strokeOpacity: "null",
    x: 216.944001,
    y: 398.899891,
    width: 599.434812,
    height: 35,
    id: "svg_105",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    x1: 217.01391,
    y1: 375.524791,
    x2: 217.01391,
    y2: 433.83431,
    id: "svg_106",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 813.209277,
    y: 372.538129,
    id: "svg_107",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 333.364801,
    y: 370.926737,
    id: "svg_108",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 453.460503,
    y: 372.6016,
    id: "svg_109",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 573.496339,
    y: 372.538129,
    id: "svg_110",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 693.220169,
    y: 372.336326,
    id: "svg_111",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "4"), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 816.791142,
    y1: 375.546983,
    x2: 816.791142,
    y2: 433.856502,
    id: "svg_112",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 336.987323,
    y1: 375.228518,
    x2: 336.987323,
    y2: 433.538037,
    id: "svg_113",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 456.610774,
    y1: 375.387751,
    x2: 456.610774,
    y2: 433.69727,
    id: "svg_114",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 576.929212,
    y1: 375.387744,
    x2: 576.929212,
    y2: 433.697263,
    id: "svg_115",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 696.727028,
    y1: 375.387744,
    x2: 696.727028,
    y2: 433.697263,
    id: "svg_116",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 756.181979,
    y: 369.867864,
    width: 0.957121,
    height: 64.103537,
    id: "svg_117",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 276.404911,
    y: 370.0271,
    width: 0.957121,
    height: 64.103537,
    id: "svg_118",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 396.309368,
    y: 370.0271,
    width: 0.957121,
    height: 64.103537,
    id: "svg_119",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 516.213828,
    y: 369.708628,
    width: 0.957121,
    height: 64.103537,
    id: "svg_120",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 636.436757,
    y: 370.0271,
    width: 0.957121,
    height: 64.103537,
    id: "svg_121",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DDDDDD",
    strokeWidth: 0,
    strokeOpacity: "null",
    x: 216.944001,
    y: 498.899891,
    width: 599.434812,
    height: 35,
    id: "svg_122",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    x1: 217.01391,
    y1: 475.524791,
    x2: 217.01391,
    y2: 533.83431,
    id: "svg_123",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 813.209277,
    y: 472.538129,
    id: "svg_124",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 333.364801,
    y: 470.926737,
    id: "svg_125",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 453.460503,
    y: 472.6016,
    id: "svg_126",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 573.496339,
    y: 472.538129,
    id: "svg_127",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "null",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 693.220169,
    y: 472.336326,
    id: "svg_128",
    fontSize: 12,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "4"), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 816.791142,
    y1: 475.546983,
    x2: 816.791142,
    y2: 533.856502,
    id: "svg_129",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 336.987323,
    y1: 475.228518,
    x2: 336.987323,
    y2: 533.538037,
    id: "svg_130",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 456.610774,
    y1: 475.387751,
    x2: 456.610774,
    y2: 533.69727,
    id: "svg_131",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 576.929212,
    y1: 475.387744,
    x2: 576.929212,
    y2: 533.697263,
    id: "svg_132",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: "null",
    x1: 696.727028,
    y1: 475.387744,
    x2: 696.727028,
    y2: 533.697263,
    id: "svg_133",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 756.181979,
    y: 469.867864,
    width: 0.957121,
    height: 64.103537,
    id: "svg_134",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 276.404911,
    y: 470.0271,
    width: 0.957121,
    height: 64.103537,
    id: "svg_135",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 396.309368,
    y: 470.0271,
    width: 0.957121,
    height: 64.103537,
    id: "svg_136",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 516.213828,
    y: 469.708628,
    width: 0.957121,
    height: 64.103537,
    id: "svg_137",
    strokeWidth: 0,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeOpacity: "null",
    x: 636.436757,
    y: 470.0271,
    width: 0.957121,
    height: 64.103537,
    id: "svg_138",
    strokeWidth: 0,
    stroke: "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcsfAnalysisGraph);
export default __webpack_public_path__ + "static/media/acsf-analysis-graph.edba01d4ab9eb126d56ff52d5d4ab797.svg";
export { ForwardRef as ReactComponent };